/* CONSENTMO COOKIE BANNER — getting the theme's stylesheet inside the app's shadow root,
   and giving the nodes we need hooks of our own.

   Consentmo draws its banner inside a custom element, <csm-cookie-consent>, that owns an
   open shadow root. Shadow DOM is a style boundary: a stylesheet in the document reaches
   the host element and nothing inside it, so assets/cookie-consent.css loaded the normal
   way styles nothing. This puts the same file where it can be seen.

   Open, not closed — element.shadowRoot answers, so the theme is allowed in. A closed
   root would leave only the app's own Custom CSS field, which is a paid plan.

   WHY THIS FILE ALSO STAMPS ATTRIBUTES. The app names some nodes (.cc-message, .cc-link,
   .cc-btn) and not others: the card itself carries no class the theme can rely on, and
   the white fade at the foot of the preferences dialog carries none at all. Rather than
   guess, the nodes are found by what they are — the painted box around the message, the
   descendant whose background is a gradient — and marked with data-dutcher-cc. The
   stylesheet then styles our own attribute instead of their class, which is the theme's
   standing rule for app markup and survives a rename on their side.

   What crosses the boundary on its own and does not need re-declaring in there:
   @font-face rules are document-scoped, so "Details Slab" and "Supreme" from
   critical.css.liquid already resolve inside the shadow root. */
(function () {
  'use strict';

  if (window.themeCookieConsentSkin) return;
  window.themeCookieConsentSkin = true;

  var script = document.currentScript;
  var href = script && script.dataset.stylesheet;
  if (!href) return;

  /* The accessibility widget is a second element from the same app, with its own root.
     Only the cookie banner is skinned for now; the list is here so adding it later is a
     one-line change rather than a second copy of this file. */
  var HOSTS = ['csm-cookie-consent'];

  var MARK = 'data-dutcher-skin';
  var HOOK = 'data-dutcher-cc';

  function inject(root) {
    if (root.querySelector('[' + MARK + ']')) return;

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute(MARK, '');
    root.appendChild(link);
  }

  function painted(node) {
    var style = getComputedStyle(node);
    /* Anything that is not the default fully transparent black counts as painted. A card
       the app draws in white, in plume, or in the merchant's own pick all qualify. */
    return style.backgroundColor !== 'rgba(0, 0, 0, 0)' && style.backgroundColor !== 'transparent';
  }

  /* The card is the nearest painted ancestor of the message — nearest, not outermost,
     because a scrim behind the banner is painted too and would win a walk to the top. */
  function findPanel(root) {
    var message = root.querySelector('.cc-message');
    if (!message || message.closest('.cc-settings-dialog')) return null;

    var node = message.parentElement;
    while (node && node !== root) {
      if (painted(node)) return node;
      node = node.parentElement;
    }
    return null;
  }

  /* The fade at the foot of the dialog's scroll area is a gradient and nothing else in
     there is, so "has a gradient background" identifies it without a name. Our own
     repaint is a gradient too, which is why the stamp is idempotent rather than a
     one-shot: re-running finds the same node and re-marks it. */
  function findFades(root) {
    var found = [];
    root.querySelectorAll('div, span').forEach(function (node) {
      if (getComputedStyle(node).backgroundImage.indexOf('gradient') !== -1) found.push(node);
    });
    return found;
  }

  function stamp(root) {
    var panel = findPanel(root);
    if (panel) panel.setAttribute(HOOK, 'panel');

    findFades(root).forEach(function (node) {
      node.setAttribute(HOOK, 'fade');
    });
  }

  /* The app re-renders its own shadow content when the shopper opens the preferences
     dialog, and a re-render drops both the link and the stamps. Watching the root costs
     nothing and means the skin survives that. The stamp is deferred a frame so it reads
     backgrounds the app has actually painted, not a half-built tree. */
  function refresh(root) {
    inject(root);
    requestAnimationFrame(function () {
      stamp(root);
    });
  }

  function keep(root) {
    refresh(root);
    new MutationObserver(function () {
      refresh(root);
    }).observe(root, { childList: true, subtree: true });
  }

  /* The element is defined by the app embed's script, which loads on its own schedule:
     at the time this file runs the tag may not exist, or may exist without having been
     upgraded yet (no shadow root until the constructor has run). Polling one frame at a
     time covers both without racing customElements.whenDefined, which resolves before
     the instance is attached. ~10s at 60fps, then it gives up rather than spinning for
     the life of the page — a shop with the embed off never gets a banner at all. */
  var tries = 0;

  function look() {
    var pending = false;

    HOSTS.forEach(function (tag) {
      var host = document.querySelector(tag);
      if (host && host.shadowRoot) {
        keep(host.shadowRoot);
      } else {
        pending = true;
      }
    });

    if (!pending) return;
    if (++tries > 600) return;
    requestAnimationFrame(look);
  }

  look();
})();
